import React from 'react'
import PropTypes from 'prop-types'
import './style.sass'
import CenteredModal from '../CenteredModal'

const ConfirmationModal = ({
  title,
  description,
  show,
  onConfirm,
  onCancel,
  btnDisabled = false
}) => {

  return (
    <div className='confirmation-modal-component-container'>
      <CenteredModal
        show={show}
        title={title}
        successBtnText="Yes"
        onSuccess={onConfirm}
        cancelBtnText="Cancel"
        onHide={onCancel}
        btnDisabled={btnDisabled}
      >
        <p>{description}</p>
      </CenteredModal>
    </div>
  )
}

ConfirmationModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  show: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  btnDisabled: PropTypes.bool
}

export default ConfirmationModal